<template>
	<inertia-head title="TRC Stock Updates" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Stock Updates[OLD]</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Exclusive stock updates to become one step ahead with other
						investors
					</h2>
				</div>
			</div>
		</div>
	</div>

	<modal ref="modal" size="modal-lg">
		<template #title>
			Stock Update Video
		</template>
		<template #body>
			<div class="mb-4">
				<VimeoIframe :videoId="selectedMaterial.video_id" />
			</div>
		</template>
	</modal>

	<div class="content mt-5">
		<button
			@click="
				$inertia.visit(route('member.updates.stock-updates'), {
					preserveScroll: false,
				})
			"
			id="scroll_top"
			class="btn btn-secondary opacity-75 d-none"
		>
			<i class="fa fa-arrow-up"></i>
		</button>
		<div v-if="materials.data.length > 0" class="row pb-4">
			<!--START Posts -->
			<div v-for="material in userMaterials.data" :key="material.id" class="col-xl-3 col-lg-4 col-md-4 mt-4">
				<div class="pb-4 mb-4 border bg-white shadow" :set="bg_rand=Math.floor(Math.random() * 5)">
					<div :class="['bg-op-primary','bg-op-success','bg-op-warning','bg-op-info','bg-op-danger'][bg_rand]">
						<div
							class="overflow-hidden rounded mb-3 bg-image text-center"
							:class="['bg-op-primary','bg-op-success','bg-op-warning','bg-op-info','bg-op-danger'][bg_rand]"
							:style="'background-image:url('+material.card+')'"
							style="
								height: 400px;
								background-size: contain;
								background-position: center;
								background-repeat: no-repeat;
								/*background-blend-mode:color-burn;*/
							"
						>
						</div>
					</div>
					<div class="p-3 pt-0" style="height: 110px;">
						<p class="mb-1 text-center fs-sm">{{ material.title }}</p>
						<div class="fs-sm fw-medium text-muted mb-2 text-center">
							<span class="me-3 fs-xs">
								<i class="fa fa-fw fa-calendar-alt opacity-50 me-1"></i>
								{{ material.date_created }}
							</span>
							<span class="fs-xs">
								<i class="fa fa-fw fa-tag opacity-50 me-1"></i>
								Stock Update
							</span>
						</div>
					</div>
					<!-- <p v-if="material.message" v-html="material.message" class="fs-sm mb-2" /> -->
					<div class="space-x-1 text-center">
						<a
							v-if="material.pdf"
							:href="'/member/download/user-materials/pdf/' + material.pdf + '?module=stock-updates'" target="_blank"
							class="btn btn-alt-primary btn-sm mb-2"
						>
							<i class="fa fa-cloud-download-alt me-1"></i>
							Download
						</a>
						<button v-if="material.video_id" @click="selectMatertial(material.video_id)" type="button" class="btn btn-alt-info btn-sm ms-2 mb-2">
							<i class="fa fa-video me-1"></i>
							Watch Video
						</button>
					</div>
				</div>
			</div>
			<nav class="d-flex justify-content-between align-items-center push">
				<inertia-link
					v-if="materials.prev_page_url"
					:href="materials.prev_page_url"
					class="btn btn-secondary"
					:class="{ disabled: !materials.prev_page_url }"
				>
					<i class="fa fa-arrow-left opacity-50 me-1"></i>
					<span>Prev</span>
				</inertia-link>
				<inertia-link
					v-if="materials.next_page_url"
					:href="materials.next_page_url"
					class="btn btn-secondary"
					:class="{ disabled: !materials.next_page_url }"
				>
					<span>Next</span>
					<i class="fa fa-arrow-right opacity-50 ms-1"></i>
				</inertia-link>
			</nav>
			<hr class="d-xl-none" />
			<!-- END Posts -->

			<!-- <div class="col-xl-4">
				<div class="block block-rounded">
					<div class="block-header block-header-default">
						<h3 class="block-title text-uppercase">Twitter Feed</h3>
						<div class="block-options">
							<a class="btn btn-sm btn-alt-secondary" href="javascript:void(0)">
								<i class="si si-social-twitter opacity-50 me-1"></i> Follow Us
							</a>
						</div>
					</div>
					<div class="block-content block-content-full space-y-3">
						<div class="d-flex">
							<img
								class="img-avatar img-avatar32 flex-shrink-0 me-3"
								src="assets/media/avatars/avatar13.jpg"
								alt=""
							/>
							<div class="flex-grow-1">
								<p class="fs-sm fw-medium mb-1">
									In gravida nulla. Nulla vel metus scelerisque ante
									sollicitudin.
									<a class="text-elegance" href="javascript:void(0)"
										>#startup</a
									>
									<a class="text-elegance" href="javascript:void(0)">#life</a>
								</p>
								<div class="fs-sm fw-medium opacity-75 text-muted">
									10 hrs ago
								</div>
							</div>
						</div>
						<div class="d-flex">
							<img
								class="img-avatar img-avatar32 flex-shrink-0 me-3"
								src="assets/media/avatars/avatar5.jpg"
								alt=""
							/>
							<div class="flex-grow-1">
								<p class="fs-sm fw-medium mb-1">
									Vestibulum in vulputate at, tempus viverra turpis. Fusce
									<a href="javascript:void(0)">condimentum</a> nunc ac nisi
									vulputate fringilla.
								</p>
								<div class="fs-sm fw-medium opacity-75 text-muted">
									15 hrs ago
								</div>
							</div>
						</div>
						<div class="d-flex">
							<img
								class="img-avatar img-avatar32 flex-shrink-0 me-3"
								src="assets/media/avatars/avatar6.jpg"
								alt=""
							/>
							<div class="flex-grow-1">
								<p class="fs-sm fw-medium mb-1">
									In gravida nulla. Nulla vel metus scelerisque ante
									sollicitudin.
								</p>
								<div class="fs-sm fw-medium opacity-75 text-muted">
									2 days ago
								</div>
							</div>
						</div>
						<div class="d-flex">
							<img
								class="img-avatar img-avatar32 flex-shrink-0 me-3"
								src="assets/media/avatars/avatar16.jpg"
								alt=""
							/>
							<div class="flex-grow-1">
								<p class="fs-sm fw-medium mb-1">
									Vestibulum in vulputate at, tempus viverra turpis. Fusce
									condimentum <a href="javascript:void(0)">nunc</a> ac nisi
									vulputate fringilla.
									<a class="text-elegance" href="javascript:void(0)">#web</a>
									<a class="text-elegance" href="javascript:void(0)">#stuff</a>
								</p>
								<div class="fs-sm fw-medium opacity-75 text-muted">
									5 days ago
								</div>
							</div>
						</div>
						<div class="d-flex">
							<img
								class="img-avatar img-avatar32 flex-shrink-0 me-3"
								src="assets/media/avatars/avatar8.jpg"
								alt=""
							/>
							<div class="flex-grow-1">
								<p class="fs-sm fw-medium mb-1">
									Vestibulum in vulputate at, tempus viverra turpis. Fusce
									<a href="javascript:void(0)">condimentum</a> nunc ac nisi
									vulputate fringilla.
								</p>
								<div class="fs-sm fw-medium opacity-75 text-muted">
									1 week ago
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="block block-rounded">
					<div class="block-header block-header-default">
						<h3 class="block-title text-uppercase">
							<i class="fa fa-fw fa-list opacity-50 me-1"></i> Categories
						</h3>
					</div>
					<div class="block-content p-3">
						<ul class="nav nav-pills flex-column">
							<li class="nav-item">
								<a
									class="nav-link d-flex align-items-center justify-content-between"
									href="javascript:void(0)"
								>
									<span
										><i class="fa fa-fw fa-star opacity-50 me-1"></i> News</span
									>
									<span class="badge rounded-pill bg-black-50">59</span>
								</a>
							</li>
							<li class="nav-item">
								<a
									class="nav-link d-flex align-items-center justify-content-between"
									href="javascript:void(0)"
								>
									<span
										><i class="fa fa-fw fa-magic opacity-50 me-1"></i> Special
										Offers</span
									>
									<span class="badge rounded-pill bg-black-50">40</span>
								</a>
							</li>
							<li class="nav-item">
								<a
									class="nav-link d-flex align-items-center justify-content-between"
									href="javascript:void(0)"
								>
									<span
										><i class="fa fa-fw fa-briefcase opacity-50 me-1"></i>
										Products</span
									>
									<span class="badge rounded-pill bg-black-50">95</span>
								</a>
							</li>
							<li class="nav-item">
								<a
									class="nav-link d-flex align-items-center justify-content-between"
									href="javascript:void(0)"
								>
									<span
										><i class="fa fa-fw fa-pencil-alt opacity-50 me-1"></i>
										Tutorials</span
									>
									<span class="badge rounded-pill bg-black-50">25</span>
								</a>
							</li>
							<li class="nav-item">
								<a
									class="nav-link d-flex align-items-center justify-content-between"
									href="javascript:void(0)"
								>
									<span>
										<i class="fa fa-fw fa-book opacity-50 me-1"></i>
										Guides
									</span>
									<span class="badge rounded-pill bg-black-50">49</span>
								</a>
							</li>
							<li class="nav-item">
								<a
									class="nav-link d-flex align-items-center justify-content-between"
									href="javascript:void(0)"
								>
									<span
										><i class="far fa-fw fa-newspaper opacity-50 me-1"></i>
										Updates</span
									>
									<span class="badge rounded-pill bg-black-50">78</span>
								</a>
							</li>
						</ul>
					</div>
				</div>

				<div class="block block-rounded">
					<div class="block-header block-header-default">
						<h3 class="block-title text-uppercase">
							<i class="fa fa-fw fa-tags opacity-50 me-1"></i> Tag Cloud
						</h3>
					</div>
					<div class="block-content p-3 space-x-1">
						<a
							class="btn btn-sm btn-alt-secondary mb-1"
							href="javascript:void(0)"
						>
							<i class="fa fa-tag text-muted opacity-50 me-1"></i> html5
						</a>
						<a
							class="btn btn-sm btn-alt-secondary mb-1"
							href="javascript:void(0)"
						>
							<i class="fa fa-tag text-muted opacity-50 me-1"></i> css3
						</a>
						<a
							class="btn btn-sm btn-alt-secondary mb-1"
							href="javascript:void(0)"
						>
							<i class="fa fa-tag text-muted opacity-50 me-1"></i> javascript
						</a>
						<a
							class="btn btn-sm btn-alt-secondary mb-1"
							href="javascript:void(0)"
						>
							<i class="fa fa-tag text-muted opacity-50 me-1"></i> angular2
						</a>
						<a
							class="btn btn-sm btn-alt-secondary mb-1"
							href="javascript:void(0)"
						>
							<i class="fa fa-tag text-muted opacity-50 me-1"></i> vuejs
						</a>
						<a
							class="btn btn-sm btn-alt-secondary mb-1"
							href="javascript:void(0)"
						>
							<i class="fa fa-tag text-muted opacity-50 me-1"></i> react
						</a>
						<a
							class="btn btn-sm btn-alt-secondary mb-1"
							href="javascript:void(0)"
						>
							<i class="fa fa-tag text-muted opacity-50 me-1"></i> php
						</a>
						<a
							class="btn btn-sm btn-alt-secondary mb-1"
							href="javascript:void(0)"
						>
							<i class="fa fa-tag text-muted opacity-50 me-1"></i> ruby
						</a>
						<a
							class="btn btn-sm btn-alt-secondary mb-1"
							href="javascript:void(0)"
						>
							<i class="fa fa-tag text-muted opacity-50 me-1"></i> jquery
						</a>
						<a
							class="btn btn-sm btn-alt-secondary mb-1"
							href="javascript:void(0)"
						>
							<i class="fa fa-tag text-muted opacity-50 me-1"></i> modern
						</a>
						<a
							class="btn btn-sm btn-alt-secondary mb-1"
							href="javascript:void(0)"
						>
							<i class="fa fa-tag text-muted opacity-50 me-1"></i> dashboard
						</a>
						<a
							class="btn btn-sm btn-alt-secondary mb-1"
							href="javascript:void(0)"
						>
							<i class="fa fa-tag text-muted opacity-50 me-1"></i> themes
						</a>
						<a
							class="btn btn-sm btn-alt-secondary mb-1"
							href="javascript:void(0)"
						>
							<i class="fa fa-tag text-muted opacity-50 me-1"></i> freebies
						</a>
					</div>
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);
	
import axios from 'axios'
import { debounce } from 'lodash'
import { onMounted, ref, reactive } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'

export default {
	layout: AuthLayout,
	props: {
		materials: Object,
	},
	setup(props) {
		const modal 			= ref(null);
		let userMaterials 		= ref(props.materials);
		const selectedMaterial 	= reactive({video_id:null});

		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')

			window.addEventListener(
				'scroll',
				debounce((e) => {
					const pixelsFromBottom =
						document.documentElement.offsetHeight -
						document.documentElement.scrollTop -
						window.innerHeight

					if (pixelsFromBottom < 200) {
						axios.get(userMaterials.value.next_page_url).then((response) => {
							userMaterials.value = {
								...response.data,
								data: [...userMaterials.value.data, ...response.data.data],
							}
						})
					}

					if (
						document.body.scrollTop > 20 ||
						document.documentElement.scrollTop > 20
					) {
						document.getElementById('scroll_top').classList.remove('d-none')
					} else {
						document.getElementById('scroll_top').classList.add('d-none')
					}
				}, 100)
			)
		})

		const selectMatertial = (video_id)=>{
			selectedMaterial.video_id = video_id;
			modal.value.toggleModal();
		}

		return {
			modal,
			userMaterials,
			selectMatertial,
			selectedMaterial
		}
	},
}
</script>
